<template>
  <v-main>
    <v-card
    :ripple="false"
    :img="ImgCover"
    height="240px"
    width="100%"
    >
    </v-card>
    <v-card class="pa-6 pb-10 mt-n10"
    :color="DarkModeBackground"
          :style="'background-color:'+ DarkModeBackground +';min-height: 100vh;border-radius: 45px 45px 0px 0px;'"
          >
        <v-row>
          <v-col class="text-center">
            <v-avatar class="mt-n16 pa-1" style="" :color="DarkModeBackground" size="150">
            <img
              :src="LoGo"
            >
          </v-avatar>
          </v-col>
         </v-row>
    <v-card class="pa-3 pt-6 pb-6 mt-16" >
      <div class="d-flex justify-center">
        <h5>{{ textStatus }}</h5>
      </div>
    </v-card>
    </v-card>
  </v-main>
</template>

<script>
import axios from 'axios' // api
export default {
  components: {
  },
  data () {
    return {
      ColorByShop: [],
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '',
      DarkModefont: '',
      shop: [],
      LoGo: [],
      ImgCover: '',
      shopId: null,
      empId: null,
      textStatus: ''
    }
  },
  async mounted () {
    console.log('----------', this.$route.query)
    let checkShopId = ''
    if (this.$route.query.shopId) {
      checkShopId = this.$route.query.shopId
      this.shopId = this.$route.query.shopId
      await this.getShop()
    } else {
      const queryString = decodeURIComponent(
        window.location.search
      ).replace('?liff.state=', '')
      console.log('queryString', queryString)
      const params = new URLSearchParams(queryString)
      checkShopId = params.get('shopId')
    }
    let dataLineConfig = await this.getDataLineConfig(checkShopId)
    this.shopId = checkShopId
    await this.checkLiffLogin(dataLineConfig)
    if (this.$route.query.empId) {
      this.empId = this.$route.query.empId
      await this.getEmployee(this.empId)
    } else {
      this.setStatusText('ผูกไลน์ไอดี ไม่สำเร็จ')
      this.$swal({
        title: 'ผิดพลาด',
        text: 'ข้อมูลไม่ครบกรุณาลองใหม่อีกครั้ง',
        type: 'info',
        showConfirmButton: true
      })
        .then(async response => {
          // this.gotoThank()
        })
        .catch(error => {
          console.log('error: ', error)
          // this.gotoThank()
        })
    }
  },
  methods: {
    async saveLineUserId (empId, userId) {
      let obj = {
        'lineUserId': userId
      }
      await axios.post(this.DNS_IP + '/empSelect/edit/' + empId, obj)
        .then(response => {
          console.log('response', response)
          if (response.data.status) {
            this.$swal({
              title: 'successfully',
              text: `ผูกไลน์ไอดีสำเร็จ`,
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
            this.setStatusText('ผูกไลน์ไอดีสำเร็จ')
          } else {
            this.$swal({
              title: 'ผิดพลาด',
              text: 'ผูกไลน์ไอดี ไม่สำเร็จ',
              type: 'info',
              timer: 2000,
              showConfirmButton: true
            })
            this.setStatusText('ผูกไลน์ไอดี ไม่สำเร็จ')
          }
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    async getEmployee (empId) {
      try {
        let employee = await axios.get(this.DNS_IP + '/empSelect/get?empId=' + empId)
        if (employee.data.length > 0) {
          this.saveLineUserId(empId, this.profile.userId)
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    setStatusText (text) {
      this.textStatus = text
    },
    async checkLiffLogin (dataLineConfig) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile()
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getBotinfo () {
      if (this.$route.query.shopId) {
        const url = `${this.DNS_IP}/line/getOa`
        // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
        const config = {
          headers: {
            botId: this.$route.query.shopId
          }
        }
        await axios.get(url, config).then(response => {
          let rs = response.data
          console.log('rs1', rs)
          window.location.href = 'line://ti/p/' + rs.basicId
        })
      }
    },
    async getShop () {
      if (this.$route.query.shopId) {
        await axios.get(this.DNS_IP + '/sys_shop/get?shopId=' + this.shopId).then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.shop = rs
            console.log('this.shop', this.shop)
            rs.forEach(v => {
              if (v.primaryColor) {
                this.ColorByShop.push(v.primaryColor, v.secondaryColor)
                this.DarkModeBackground = v.primaryColor
                this.DarkModeButton = v.secondaryColor
              } else {
                this.ColorByShop.push('#E1F3FF', '#FFFFFF')
                this.DarkModeBackground = '#FFFFFF'
                this.DarkModeButton = '#E1F3FF'
              }
              if (v.shopImge) {
                this.LoGo = v.shopImge
              } else {
                this.LoGo = require('@/assets/Thank.svg')
              }
              if (v.shopImageCover) {
                this.ImgCover = v.shopImageCover
              } else {
                if (v.category === 'ธุรกิจรถยนต์') {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                } else {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                }
              }
              if (v.darkMode === 'True') {
                this.DarkMode = '#FFFFFF'
                this.DarkModefont = '#FFFFFF'
              } else {
                this.DarkMode = ''
                this.DarkModefont = '#173053'
              }
            })
          } else {
            this.shop = null
          }
        })
      } else {
        this.ColorByShop.push('#E1F3FF', '#FFFFFF')
        this.LoGo = require('@/assets/Thank.svg')
        this.DarkMode = ''
        this.DarkModefont = '#173053'
      }
    }
  }
}
</script>

<style scoped>
.button {
  width: 45%;
  color: #fff;
  font-weight: 200;
  letter-spacing: 1px;
  margin: 6px 3px;
  padding: 10px 28px;
  border-radius: 25px !important;
  background-color: #0047a5;
}
.main {
  background-color: #ffffff;
  height: 100vh;
}
.content {
  overflow: auto;
  white-space: normal;
}
.a {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/SaveUserIdEmployee.vue